import { createSlice } from "@reduxjs/toolkit"
import { fynitoApi } from "../../../Components/Services/axios";
// Direct toast import removed - using toastify helper instead
import toastify from "../../../helper/toastify";
import apiCache from "../../../services/apiCache";

// const initialState = {
//     couponList: [],
//     selectedCouponId: null,
//     discount: 0,
//     discountType: "",
//     couponCode: "",
// }

// Load initial state from localStorage if available
const loadInitialState = () => {
    try {
        const savedCouponData = localStorage.getItem('couponData');
        if (savedCouponData) {
            return JSON.parse(savedCouponData);
        }
    } catch (error) {
        console.error("Error loading coupon data from localStorage:", error);
    }
    return {
        couponList: [],
        selectedCouponId: null,
        discount: 0,
        discountType: "",
        couponCode: "",
    };
};
const initialState = loadInitialState();
const copuponSlice = createSlice({
    name: 'coupon',
    initialState,
    reducers: {
        setCouponList: (state, action) => {
            state.couponList = action.payload;
        },
        setCoupon: (state, action) => {
            state.selectedCouponId = action.payload.id || null;
            state.discount = action.payload.discount || 0;
            state.discountType = action.payload.discount_type || '';
            state.couponCode = action.payload.coupon_code || '';
            localStorage.setItem('couponData', JSON.stringify({
                ...state,
                selectedCouponId: state.selectedCouponId,
                discount: state.discount,
                discountType: state.discountType,
                couponCode: state.couponCode,
            }))
        },
        clearCoupon: (state) => {
            state.selectedCouponId = null;
            state.discount = 0;
            state.discountType = '';
            state.couponCode = '';
            localStorage.removeItem('couponData')
        },
    }
})

export const { setCouponList, setCoupon, clearCoupon } = copuponSlice.actions;

export const fetchCoupons = (payload) => async (dispatch) => {
  try {
    // Check cache first
    const cacheKey = apiCache.getCacheKey('/offer-list', 'POST', {}, payload);
    const cachedData = apiCache.get(cacheKey, 180000); // 3 minutes cache
    
    if (cachedData) {
      const adminCoupons = cachedData?.admin || [];
      const restaurantCoupons = cachedData?.restaurant || [];
      const combinedCoupons = [...adminCoupons, ...restaurantCoupons];
      dispatch(setCouponList(combinedCoupons));
      return;
    }
    
    // Check if request is already pending
    if (apiCache.isPending(cacheKey)) {
      const pendingResponse = await apiCache.getPending(cacheKey);
      if (pendingResponse?.data?.status_code === 200) {
        const adminCoupons = pendingResponse.data.data?.admin || [];
        const restaurantCoupons = pendingResponse.data.data?.restaurant || [];
        const combinedCoupons = [...adminCoupons, ...restaurantCoupons];
        dispatch(setCouponList(combinedCoupons));
        apiCache.set(cacheKey, pendingResponse.data.data);
      }
      return;
    }
    
    // Make API call with pending request tracking
    const requestPromise = fynitoApi.post('/offer-list', payload);
    apiCache.setPending(cacheKey, requestPromise);
    
    const res = await requestPromise;
    
    if (res.data.status_code === 200) {
      // Combine both admin and restaurant arrays from API response
      const adminCoupons = res.data.data?.admin || [];
      const restaurantCoupons = res.data.data?.restaurant || [];
      const combinedCoupons = [...adminCoupons, ...restaurantCoupons];
      dispatch(setCouponList(combinedCoupons)); // ✅ Sets all coupons (admin + restaurant) into Redux store
      apiCache.set(cacheKey, res.data.data);
    } else {
      toastify.error(res.data.message);
    }
  } catch (error) {
    // Check if request was canceled (aborted)
    if (error.name === 'CanceledError' || error.message?.includes('canceled')) {
      return; // Silently handle canceled requests
    }
    console.error("Error fetching coupons:", error);
  }
};


export const applyCoupon = (payload) => async (dispatch) => {
    try {
        const res = await fynitoApi.post('/offer-apply', payload);
        if (res.data.status_code === 200) {
            document.querySelector('.btn-close').click();
            toastify.success(res.data.message);
            return { success: true }
        } else {
            toastify.error(res.data.message);
            return { success: false }
        }
    } catch (error) {
        return { success: false }
    }
}

export default copuponSlice.reducer;